import { isCompleteOtp } from "@/lib/otp";

export type EmailOtpType = "email" | "magiclink";

type OtpError = { code?: string; message?: string } | null;

export type OtpAttemptResult<T> = {
  data: T;
  error: OtpError;
};

/**
 * The invariant lives at the provider boundary: every attempt, including the
 * token-type fallback, validates the exact token it is about to transmit.
 */
export async function verifyOtpWithTypeFallback<T>(
  token: string,
  verify: (type: EmailOtpType, guardedToken: string) => Promise<OtpAttemptResult<T>>,
): Promise<OtpAttemptResult<T>> {
  const attempt = (type: EmailOtpType) => {
    if (!isCompleteOtp(token)) {
      throw new Error("OTP_PROVIDER_CALL_BLOCKED_INVALID_LENGTH");
    }
    return verify(type, token);
  };

  let result = await attempt("email");
  if (result.error) {
    const providerCode = result.error.code ?? "";
    const notFound =
      providerCode === "otp_expired" ||
      /invalid or has expired|not found/i.test(result.error.message ?? "");

    if (notFound) result = await attempt("magiclink");
  }

  return result;
}